import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import numeral from "numeral";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";
import { TurnOverReports } from "../../../components/PDF/TurnOverReportPdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const TurnOverSummary = () => {
  const [pkgSalesItem, setPkgSalesItem] = useState([]);
  const [pkgTurnOverDate, setPkgTurnOverDate] = useState([]);
  const [pkgTotal, setPkgTotal] = useState([]);

  const [wholesaleSalesItem, setWholeSaleItem] = useState([]);
  const [wholesaleTurnOverDate, setWholesaleTurnOverDate] = useState([]);
  const [wholesaleTotal, setWholesaleTotal] = useState([]);
  
  const [upgSalesItem, setUpgSalesItem] = useState([]);
  const [upgTurnOverDate, setUpgTurnOverDate] = useState([]);
  const [upgTotal, setUpgTotal] = useState([]);

  const [drSalesItem, setDrSalesItem] = useState([]);
  const [drTurnOverDate, setDrTurnOverDate] = useState([]);
  const [packageDetails, setPackageDetails] = useState([]);
  const [wholesaleDetails, setWholesaleDetails] = useState([]);
  const [upgDetails, setUpgDetails] = useState([]);
  const [drDetails, setDrdetails] = useState([]);
  const [drTotal, setDrTotal] = useState([]);
  const [drPaymentTotal, setDrPaymentTotal] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const [mergedItems, setMergedItems] = useState([]);
  const classes = useStyles();
  const [branchidNo, setbranchidNo] = useState(get_cookies("branchidno"));

  // Data Fetching
  useEffect(() => {
    setDataLoaded(true);
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    if (pkgSalesItem.length > 0 && drSalesItem.length > 0) {
      setDownloadFlag(true);
    }
  }, [pkgSalesItem, drSalesItem]);
  //search button

  const handleDataMerge = (packageItems, directItems,wholesaleItems,upgradeItems) => {
    // Create a map to track types and their summed amounts
    const itemMap = new Map();

    // Function to add or sum items in the map
    const addItemToMap = (items) => {
      items.forEach((item) => {
        if (itemMap.has(item.type)) {
          // If the type already exists, sum the amounts
          const existingAmount = itemMap.get(item.type);
          itemMap.set(item.type, existingAmount + item.amount);
        } else {
          // If not, add the item type and amount to the map
          itemMap.set(item.type, item.amount);
        }
      });
    };
    // Process both arrays
    addItemToMap(packageItems);
    addItemToMap(directItems);
    addItemToMap(wholesaleItems);
    addItemToMap(upgradeItems);

    // Convert the map back to an array of objects
    const combinedArray = Array.from(itemMap, ([type, amount]) => ({
      type,
      amount,
    }));

    // Set the merged array in the state
    setMergedItems(combinedArray);
  };

  const getColumns = () => [
    { name: 'date', label: 'Transaction Date', options: { filter: true, sort: true } },
    { name: "idno", label: "ID No", options: { filter: true, sort: true } },
    { name: "soldto", label: "Soldto", options: { filter: true, sort: true } },
    { name: "amount", label: "Amount",       options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <div style={{ textAlign: "right" }}>
            {numeral(value).format("0,0.00")}
          </div>
          // <div>{numeral(value).format('0,0.00')}</div>
        );
      },
    }, },
  ];
  const getUpgColumns = () => [
    { name: 'date', label: 'Transaction Date', options: { filter: true, sort: true } },
    { name: "idno", label: "ID No", options: { filter: true, sort: true } },
    { name: "reference_no", label: "Ref No", options: { filter: true, sort: true } },
    { name: "amount", label: "Amount",       options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <div style={{ textAlign: "right" }}>
            {numeral(value).format("0,0.00")}
          </div>
          // <div>{numeral(value).format('0,0.00')}</div>
        );
      },
    }, },
  ];
  const getColumnsDr = () => [
    // { name: 'type', label: 'Type', options: { filter: true, sort: true } },
    { name: "trandate", label: "SO Date", options: { filter: true, sort: true } },
    // { name: "idno", label: "Idno", options: { filter: true, sort: true } },
    { name: "collectionid", label: "Collection ID", options: { filter: true, sort: true } },
    { name: "sono", label: "Sales Order", options: { filter: true, sort: true } },
    { name: "soldto", label: "Soldto", options: { filter: true, sort: true } },
    { name: "amount", label: "Payment Amount",       options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <div style={{ textAlign: "right" }}>
            {numeral(value).format("0,0.00")}
          </div>
          // <div>{numeral(value).format('0,0.00')}</div>
        );
      },
    }, },
  ];

  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/get_turnover_summary_report`, {
        params: {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"), //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_u_idno: branchidNo, //branchidNo
        },
      })
      .then(function (res) {
        setPkgSalesItem(res.data.data.package_sales.items);
        setPkgTurnOverDate(res.data.data.package_sales.turnover_date);
        setPkgTotal(res.data.data.package_sales.pkg_sales_total);
        setDrSalesItem(res.data.data.direct_sales.items);
        setDrTurnOverDate(res.data.data.direct_sales.turnover_date);
        setDrTotal(res.data.data.direct_sales.direct_sales_total);
        setDrPaymentTotal(res.data.data.direct_sales.drpaymenttotal);
        setDrdetails(res.data.data.direct_sales.direct_sales_items_details);
        setPackageDetails(res.data.data.package_sales.types);
        setUpgSalesItem(res.data.data.upgrade.items);
        setUpgTurnOverDate(res.data.data.upgrade.turnover_date);
        setUpgTotal(res.data.data.upgrade.upg_sales_total);
        setUpgDetails(res.data.data.upgrade.types);
        setWholeSaleItem(res.data.data.wholesale_set.items);
        setWholesaleTurnOverDate(res.data.data.wholesale_set.turnover_date);
        setWholesaleTotal(res.data.data.wholesale_set.wh_sales_total);
        setWholesaleDetails(res.data.data.wholesale_set.types);
        // console.log("1212", res.data.data.direct_sales.items);
        handleDataMerge(
          res.data.data.package_sales.items,
          res.data.data.direct_sales.items,
          res.data.data.wholesale_set.items,
          res.data.data.upgrade.items,
        );

        setDataLoaded(true);
      })
      .catch(function (error) {
        // console.log(error);
        setDataLoaded(true);
      });
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };

  const columns = [
    {
      name: "type",
      label: "Type",
      options: {
        filter: false,
        // display: "excluded",
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
            // <div>{numeral(value).format('0,0.00')}</div>
          );
        },
      },
    },
  ];

  const pkgOptions = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    downloadOptions: {
      filename: "TurnOverSummaryPackageSales.csv", //change filename of csv
    },
    rowsPerPage: [10],
    rowsPerPageOptions: [10, 15, 100],
    // customFooter: (
    //     count,
    //     page,
    //     rowsPerPage,
    //     changeRowsPerPage,
    //     changePage
    //   ) => {
    //     const startIndex = page * rowsPerPage;
    //     const endIndex = (page + 1) * rowsPerPage;
    //     return (
    //         <div>
    //             <TablePagination
    //                 rowsPerPageOptions={[5, 10, 25]}
    //                 component="div"
    //                 count={count}
    //                 rowsPerPage={rowsPerPage}
    //                 page={page}
    //                 changePage={handleChangePage}
    //                 changeRowsPerPage={handleChangeRowsPerPage}
    //             />
    //             <TableFooter>
    //                 <TableRow>
    //                 <TableCell colSpan={6}>
    //                 Turnover Date: {pkgTurnOverDate} <br/>
    //                 Total: {pkgTotal}
    //                     {/* Total Salery for current page: {sumSalery(startIndex, endIndex)} */}
    //                 </TableCell>
    //                 </TableRow>
    //             </TableFooter>

    //         </div>

    //     );
    //   }
    // tableBodyHeight,
  };
  const drOptions = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    downloadOptions: {
      filename: "TurnOverSummaryDirectSales.csv", //change filename of csv
    },
    rowsPerPage: [10],
    rowsPerPageOptions: [10, 15, 100],
    // customFooter: (
    //     count,
    //     page,
    //     rowsPerPage,
    //     changeRowsPerPage,
    //     changePage
    //   ) => {
    //     const startIndex = page * rowsPerPage;
    //     const endIndex = (page + 1) * rowsPerPage;
    //     return (
    //       <TableFooter>
    //         <TableRow>
    //           <TableCell colSpan={6}>
    //           Turnover Date: {drTurnOverDate} <br/>
    //           Total: {drTotal}
    //             {/* Total Salery for current page: {sumSalery(startIndex, endIndex)} */}
    //           </TableCell>
    //         </TableRow>
    //       </TableFooter>
    //     );
    //   }
    // tableBodyHeight,
  };
  // const sumSalery = (startIndex, endIndex) => {
  //     return data //data = table data
  //       .slice(startIndex, endIndex)
  //       .map(a => a[4])
  //       .reduce((total, salery) => (total += salery), 0);
  //   };

  const style = {
    marginBottom: "1rem",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AssessmentTwoTone />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/reports">
            <h2 className="header-title">Reports</h2>
          </NavLink>
          <Typography color="textPrimary">Turn Over Summary</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <div style={style}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>
            <Grid item xs={7} lg={7} xl={2}>
              <Button
                variant="contained"
                style={{ marginTop: "23px" }}
                color="primary"
                onClick={() => {
                  dataFilter();
                }}
              >
                Search
              </Button>
            </Grid>
            <Grid item xs={2} lg={2} xl={1} alignContent="flex-end">
              {!dataLoaded ? null : (
                <PDFDownloadLink
                  style={{ borderWidth: 1 }}
                  className={classes.buttonPrimary}
                  document={
                    <TurnOverReports
                      pkgSalesItem={pkgSalesItem}
                      drSalesItem={drSalesItem}
                      upgSalesItem={upgSalesItem}
                      wholesaleSalesItem={wholesaleSalesItem}
                      pkgTurnOverDate={pkgTurnOverDate}
                      pkgTotal={pkgTotal}
                      drTurnOverDate={drTurnOverDate}
                      drTotal={drTotal}
                      upgTotal={upgTotal}
                      wholesaleTotal={wholesaleTotal}
                      upgTurnOverDate={upgTurnOverDate}
                      wholesaleTurnOverDate={wholesaleTurnOverDate}
                      mergedItems={mergedItems}
                      drPaymentTotal={drPaymentTotal}
                      printby={get_cookies("username")}
                      datePrinted={format(new Date(), "yyyy-MM-dd")}
                      total={drPaymentTotal + pkgTotal +wholesaleTotal +upgTotal}
                    />
                  }
                  fileName={
                    "TurnoverReport" +
                    format(dateRange.startDate, "yyyy-MM-dd") +
                    format(dateRange.endDate, "yyyy-MM-dd") +
                    ".pdf"
                  }
                >
                  {({ blob, url, loading, error }) =>
                    loading ? (
                      "Loading document..."
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ alignSelf: "flex-end" }}
                      >
                        Print PDF
                      </Button>
                    )
                  }
                </PDFDownloadLink>
              )}
            </Grid>
          </Grid>
        </div>

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <>
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Turnover Date: {pkgTurnOverDate} <br />
                Total: {numeral(pkgTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
            <MUIDataTable
              title={
                //place header data  here
                <div>
                  {/* <div className="table-subtitle">Turn Over Summary</div> */}
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Package Sales
                  </h3>
                </div>
              }
              data={pkgSalesItem}
              columns={columns}
              options={pkgOptions}
            />

            {Object.keys(packageDetails).length > 0 ? (
              <div>
                {Object.keys(packageDetails).map((tableKey, index) => {
                  const tableData = packageDetails[tableKey];

                  return (
                    <div
                      key={index}
                      style={{ marginBottom: "20px", marginTop: "20px" }}
                    >
                      {/* <Paper elevation={3}> */}
                      <MUIDataTable
                        title={"Package Sales - " + tableKey}
                        data={tableData.map((item) => ({
                          idno: item.idno,
                          amount: item.amount,
                          soldto: item.soldto,
                          date: item.trandate,
                        }))}
                        columns={getColumns()}
                        options={{
                          filterType: "checkbox",
                          selectableRows: "none",
                          download: false, //add this
                          print: false, //add this
                          viewColumns: false,
                        }}
                      />
                      {/* </Paper> */}
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Total: {numeral(pkgTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Turnover Date: {drTurnOverDate} <br />
                Direct Sales Total: {numeral(drTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
            <MUIDataTable
              title={
                //place header data  here
                <div>
                  {/* <div className="table-subtitle">Turn Over Summary</div> */}
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Direct Sales
                  </h3>
                </div>
              }
              data={drSalesItem}
              columns={columns}
              options={drOptions}
            />
            
            {Object.keys(drDetails).length > 0? (
              <div>
                {Object.keys(drDetails).map((tableKey, index) => {
                  const tableData = drDetails[tableKey];

                  return (
                    <div
                      key={index}
                      style={{ marginBottom: "20px", marginTop: "20px" }}
                    >
                      {/* <Paper elevation={3}> */}
                      <MUIDataTable
                        title={"Direct Sales - " + tableKey}
                        data={tableData.map((item) => ({
                          idno: item.idno,
                          amount: item.amount,
                          sono: item.drno,
                          collectionid: item.id,
                          soldto: item.soldto,
                          trandate: item.trandate,
                        }))}
                        columns={getColumnsDr()}
                        options={{
                          filterType: "checkbox",
                          selectableRows: "none",
                          download: false, //add this
                          print: false, //add this
                          viewColumns: false,
                        }}
                      />
                      {/* </Paper> */}
                    </div>
                  );
                })}
              </div>
            ) : null}

            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#00000",fontSize:20 }}>
                Total: {numeral(drPaymentTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
              {/* wholesale */}
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Turnover Date: {wholesaleTurnOverDate} <br />
                Total: {numeral(wholesaleTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
            <MUIDataTable
              title={
                //place header data  here
                <div>
                  {/* <div className="table-subtitle">Turn Over Summary</div> */}
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Wholesale Set
                  </h3>
                </div>
              }
              data={wholesaleSalesItem}
              columns={columns}
              options={pkgOptions}
            />

            {Object.keys(wholesaleDetails).length > 0 ? (
              <div>
                {Object.keys(wholesaleDetails).map((tableKey, index) => {
                  const tableData = wholesaleDetails[tableKey];

                  return (
                    <div
                      key={index}
                      style={{ marginBottom: "20px", marginTop: "20px" }}
                    >
                      {/* <Paper elevation={3}> */}
                      <MUIDataTable
                        title={"Wholesale Sets - " + tableKey}
                        data={tableData.map((item) => ({
                          idno: item.idno,
                          amount: item.amount,
                          soldto: item.soldto,
                          date: item.trandate,
                        }))}
                        columns={getColumns()}
                        options={{
                          filterType: "checkbox",
                          selectableRows: "none",
                          download: false, //add this
                          print: false, //add this
                          viewColumns: false,
                        }}
                      />
                      {/* </Paper> */}
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Total: {numeral(wholesaleTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />

            {/* upgrade */}
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Turnover Date: {upgTurnOverDate} <br />
                Total: {numeral(upgTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
            <MUIDataTable
              title={
                //place header data  here
                <div>
                  {/* <div className="table-subtitle">Turn Over Summary</div> */}
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Account Upgrade
                  </h3>
                </div>
              }
              data={upgSalesItem}
              columns={columns}
              options={pkgOptions}
            />

            {Object.keys(upgDetails).length > 0 ? (
              <div>
                {Object.keys(upgDetails).map((tableKey, index) => {
                  const tableData = upgDetails[tableKey];

                  return (
                    <div
                      key={index}
                      style={{ marginBottom: "20px", marginTop: "20px" }}
                    >
                      {/* <Paper elevation={3}> */}
                      <MUIDataTable
                        title={"Upgrade - " + tableKey}
                        data={tableData.map((item) => ({
                          idno: item.idno,
                          amount: item.amount,
                          reference_no: item.reference_no,
                          date: item.trandate,
                        }))}
                        columns={getUpgColumns()}
                        options={{
                          filterType: "checkbox",
                          selectableRows: "none",
                          download: false, //add this
                          print: false, //add this
                          viewColumns: false,
                        }}
                      />
                      {/* </Paper> */}
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div style={{ width: "100%", backgroundColor: "white" }}>
              <div style={{ padding: "16px 24px", color: "#0000008A" }}>
                Total: {numeral(upgTotal).format("0,0.00")}
              </div>
            </div>
            <br />
            <br />
          </>
        )}
      </div>
    </div>
  );
};

export default TurnOverSummary;
